import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../../constants/common'
import Text from '../../../Text'
import { GretaAIChatChatListItem } from '../GretaAIChatChatListItem'
import { GretaAIChatChatListSectionToggle } from '../GretaAIChatChatListSectionToggle'

import * as styles from './GretaAIChatChatListSection.module.css'

function GretaAIChatChatListSection({
  activeChatId,
  chatStatusById = EMPTY_OBJECT,
  isCollapsible = false,
  locale,
  now,
  section: { chats, titleKey, toggleQaName },
  withRowActions = true,
  onSelectChat = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  const [isCollapsed, setIsCollapsed] = useState(false)

  function handleToggle() {
    setIsCollapsed(current => !current)
  }

  return (
    <section className={styles.section}>
      {isCollapsible ? (
        <GretaAIChatChatListSectionToggle
          isCollapsed={isCollapsed}
          qaName={toggleQaName}
          title={t(titleKey)}
          onToggle={handleToggle}
        />
      ) : (
        <Text isSecondary Element='h2' className={styles.sectionTitle}>
          {t(titleKey)}
        </Text>
      )}
      {isCollapsed ? null : (
        <ul className={styles.items}>
          {chats.map(chat => (
            <GretaAIChatChatListItem
              chat={chat}
              isActive={chat.id === activeChatId}
              key={chat.id}
              locale={locale}
              now={now}
              status={chatStatusById[chat.id] ?? null}
              withRowActions={withRowActions}
              onSelect={onSelectChat}
            />
          ))}
        </ul>
      )}
    </section>
  )
}

export default GretaAIChatChatListSection
